import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "config", "addMessages", "setIsNoNAuthStage", "captchaToken", "setQueuedMessages", "lastSession", "isOpen"];
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { FSMStages, ScrollProvider, useFSM } from "../../../../shared/model";
import { selectChatCofig, selectIsChatOpen } from "../../../../entities/settings/model";
import { addMessages as addStoreMessages, selectIsHistoryEmpty, selectLastSession, selectLoadingStatus, setIsNoNAuthCaptchaStage } from "../../../../entities/message/model";
import { selectCaptchaAccessToken, setQueuedMessages as setStoreQueuedMessages } from "../../../../entities/captcha/model";
import { NotificationProvider } from "../../../../entities/notification/model";
import { SocketProvider } from "../../../../entities/socket/model";
import { CommunicationService } from "../CommunicationService";
import { CaptchaService } from "../CaptchaService";
import { SocketService } from "../SocketService";
import { getCaptchaStageHistory, getPrevZoneType, getQueuedMessages, resetCaptchaStorage, setPrevZoneType } from "./utils";
var ContextWrapperRender = function ContextWrapperRender(_ref) {
  var _config$authZoneConfi, _config$userData;
  var children = _ref.children,
    config = _ref.config,
    addMessages = _ref.addMessages,
    setIsNoNAuthStage = _ref.setIsNoNAuthStage,
    captchaToken = _ref.captchaToken,
    setQueuedMessages = _ref.setQueuedMessages,
    lastSession = _ref.lastSession,
    isOpen = _ref.isOpen,
    others = _objectWithoutProperties(_ref, _excluded);
  var zoneType = ((_config$authZoneConfi = config.authZoneConfig) === null || _config$authZoneConfi === void 0 ? void 0 : _config$authZoneConfi.zoneType) || 'unauthorized';
  var _useFSM = useFSM(),
    stage = _useFSM.stage;
  var restore = function restore() {
    var captchaMessages = getCaptchaStageHistory(lastSession);
    var queuedMessages = getQueuedMessages();
    var prevZoneType = getPrevZoneType();
    setQueuedMessages(queuedMessages);
    setIsNoNAuthStage(stage === FSMStages.BLOCKED || stage === FSMStages.CAPTCHA_NEEDED);
    if (captchaMessages && prevZoneType === zoneType) {
      addMessages(captchaMessages);
    } else if (zoneType) {
      resetCaptchaStorage();
      setPrevZoneType(zoneType);
    }
  };
  useEffect(restore, []);
  return /*#__PURE__*/React.createElement(NotificationProvider, {
    "data-t-id": "context-\u0421ontextWrapper"
  }, /*#__PURE__*/React.createElement(ScrollProvider, _extends({
    zoneType: zoneType
  }, others, {
    "data-t-id": "context-\u0421ontextWrapper"
  }), /*#__PURE__*/React.createElement(CaptchaService, {
    "data-t-id": "context-\u0421ontextWrapper"
  }, /*#__PURE__*/React.createElement(SocketProvider, {
    config: config,
    token: zoneType === 'authorized' ? (_config$userData = config.userData) === null || _config$userData === void 0 ? void 0 : _config$userData.token : captchaToken,
    "data-t-id": "context-\u0421ontextWrapper"
  }, /*#__PURE__*/React.createElement(SocketService, {
    "data-t-id": "context-\u0421ontextWrapper"
  }, /*#__PURE__*/React.createElement(CommunicationService, {
    "data-t-id": "context-\u0421ontextWrapper"
  }, children))))));
};
var mapStateToProps = function mapStateToProps(store) {
  return {
    config: selectChatCofig(store),
    isOpen: selectIsChatOpen(store),
    lastSession: selectLastSession(store),
    loadingStatus: selectLoadingStatus(store),
    isHistoryEmpty: selectIsHistoryEmpty(store),
    captchaToken: selectCaptchaAccessToken(store)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    addMessages: function addMessages(list) {
      return dispatch(addStoreMessages(list));
    },
    setIsNoNAuthStage: function setIsNoNAuthStage(flag) {
      return dispatch(setIsNoNAuthCaptchaStage(flag));
    },
    setQueuedMessages: function setQueuedMessages(list) {
      return dispatch(setStoreQueuedMessages(list));
    }
  };
};
export var ContextWrapper = connect(mapStateToProps, mapDispatchToProps)(ContextWrapperRender);